import { saveCreativeError, saveCreativeSuccess } from 'modules/campaigns/actions';
import { addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { assignCreativesApi } from 'services/api';
import { generateErrorIndication } from 'services/utils/errorMessagesUtils';
import { successIndication, errorMessage } from './saveCreative';

export const updateAd = (accountId, creative, creativeChanges) => async dispatch => {
    try {
        const result = await assignCreativesApi.updateAd(accountId, creative.id, creativeChanges);
        dispatch(saveCreativeSuccess(result));
        dispatch(addIndication(successIndication));
        return { result };
    } catch (error) {
        dispatch(saveCreativeError(creative.id, error));
        dispatch(addIndication(generateErrorIndication(error, errorMessage)));
    }
};
